import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadDefensorResponseDto, IFullReport, RelatorioDto, RelatorioNucleoDto } from '@/api.types';

/**
 * Relatório de lotações dos defensores.
 * @param todoperiodo Verdadeiro para todos os períodos, falso para somente daqui para frente.
 * @param agrupar Se deve agrupar por...
 * @returns Dados de um relatório.
 */
export async function GetRelatorio(todoperiodo: boolean, agrupar: boolean = true) {

  try {
    const response = await api.get<RelatorioDto[]>(Endpoints.RELATORIO, { params: { todoperiodo: todoperiodo, agrupar: agrupar } })
    return response.data
  } catch (error) {
    return ValidateAxiosError(error, 'Falha ao buscar relatório');
  }
}

/**
 * Relatório completo com todos os dados, incluindo núcleos.
 * @param todoperiodo Verdadeiro para todos os períodos, falso para somente daqui para frente.
 * @param agrupar Se deve agrupar por...
 * @returns Dados completos de um relatório.
 */
export async function FullRelatorio(todoperiodo: boolean, agrupar: boolean = true) {
  try {
    const response = await api.get<IFullReport>(Endpoints.RELATORIO_LOTACOES, { params: { todoperiodo: todoperiodo, agrupar: agrupar } });
    return response.data;
  } catch (error) {
    return ValidateAxiosError<IFullReport>(error, 'Falha ao buscar relatório');
  }
}

/**
 *
 * @param todoperiodo Verdadeiro para todos os períodos, falso para somente daqui para frente.
 * @param agrupar Se deve agrupar por...
 * @returns Documento PDF.
 */
export async function GetRelatorioAsPdf(todoperiodo: boolean, agrupar: boolean = true,) {
  return api
    .get<RelatorioDto[]>(Endpoints.RELATORIO + '/pdf', {
      params: { todoperiodo: todoperiodo, agrupar: agrupar },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<RelatorioDto[]>(
        error,
        'Falha ao baixar relatório',
      );
    });
}

/**
 * Lista de defensores e seus eventos ainda válidos.
 * @param todoperiodo Exibir tudo (não somente daqui para frente).
 * @param tiposEventos Filtro por tipos de evento (vazio = todos).
 * @param dataInicial Opcional. Só eventos com data_final >= dataInicial.
 * @param dataFinal Opcional. Só eventos com data_inicial <= dataFinal.
 * @returns Objeto.
 */
export async function GetRelatorioDefensores(
  todoperiodo: boolean,
  tiposEventos?: number[],
  dataInicial?: string,
  dataFinal?: string,
) {
  const params: Record<string, string | boolean | undefined> = {
    todoperiodo,
  };
  if (tiposEventos?.length) params.tipos = tiposEventos.join(',');
  if (dataInicial) params.datainicial = dataInicial;
  if (dataFinal) params.datafinal = dataFinal;

  return api
    .get<ReadDefensorResponseDto[]>(Endpoints.RELATORIO + '/defensores', { params })
    .then((response) => response.data)
    .catch((error) => {
      return ValidateAxiosError<ReadDefensorResponseDto[]>(error, 'Falha ao buscar relatório');
    });
}

/**
 * Relatório de lotações por núcleos.
 * @returns Relatório.
 */
export async function GetRelatorioNucleo() {
  return api
    .get<RelatorioNucleoDto[]>(Endpoints.RELATORIO + '/nucleos')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<RelatorioNucleoDto[]>(error, 'Falha ao buscar relatório');
    });
}